<template>
    <v-container mb-12>
        <v-row justify="center">
            <!-- Forgot Password Image -->
            <v-col
                cols="12"
                sm="6"
            >
                <div
                    class="d-flex fill-height align-center justify-center"
                >
                    <v-img
                        max-width="80%"
                        :src="require('../../assets/unlock.svg')"
                    />
                </div>
            </v-col>

            <!-- Forgot Password Header and Form -->
            <v-col
                cols="12"
                sm="6"
            >
                <v-form
                    ref="form"
                    @submit.prevent="onSubmit"
                >
                    <v-row justify="center">
                        <v-col
                            cols="12"
                            lg="8"
                            class="text-center"
                        >
                            <h1 class="display-2 mt-3 mb-2">
                                Forgot Password
                            </h1>
                            <p>
                                Please enter your email address and we'll send you
                                instructions on how to reset your password.
                            </p>
                        </v-col>
                        <v-col cols="12" lg="8">
                            <v-text-field
                                label="Email"
                                v-model="email"
                                validate-on-blur
                                :rules="[
                                    rules.required,
                                    rules.email
                                ]"
                                color="secondary"
                            />
                        </v-col>

                        <v-col cols="12" lg="8">
                            <vue-recaptcha
                                ref="invisibleRecaptcha"
                                :sitekey="sitekey"
                                badge
                                size="invisible"
                                @verify="onVerify"
                                :load-recaptcha-script="true"
                            />
                            <div class="d-flex">
                                <v-spacer />
                                <v-btn
                                    type="submit"
                                    :loading="isSubmitting"
                                    :disabled="isSubmitting"
                                    color="primary"
                                    block
                                    large
                                >
                                    Submit
                                </v-btn>
                            </div>
                        </v-col>

                        <v-col cols="12" class="text-center">
                            Back to <router-link :to="{name: 'login'}">Login</router-link>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import { requiredValidation, emailValidation } from '../../utils/validations'
import MessageBus from '../../utils/buses/MessageBus'
import { default422Error, defaultError } from '../../utils/constants/errors'

export default {
    components: {
        VueRecaptcha
    },

    data () {
        return {
            sitekey: process.env.VUE_APP_RECAPTCHA_SITEKEY,
            email: null,
            isSubmitting: false,
            rules: {
                required: requiredValidation,
                email: emailValidation
            }
        }
    },

    methods: {
        onVerify (recaptchaResponse) {
            axios.post('/reset-password-email', {
                email: this.email,
                recaptchaResponse
            })
                .then(res => {
                    MessageBus.sendMessage(`We have sent instructions to ${this.email}`, 'success')
                    this.$refs.form.reset()
                })
                .catch(err => {
                    console.error('Error sending message', err)
                    MessageBus.sendMessage(defaultError, 'error')
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        onSubmit () {
            this.isSubmitting = true

            if (!this.$refs.form.validate()) {
                MessageBus.sendMessage(default422Error, 'error')
                this.isSubmitting = false
                return
            }

            this.$refs.invisibleRecaptcha.reset()
            this.$refs.invisibleRecaptcha.execute()
        }
    }
}
</script>
